// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2QDaq","right":"styles_right__3pBji"};